import { Chip } from "@heroui/react";
import { useState, useEffect } from "react";
import { OfficeType } from "@/api/officeTypes";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function OfficeTypeChip({ officeTypeId }: { officeTypeId: number }) {
  const [item, setItem] = useState<OfficeType | null>(null);
  const items = useAppSelector((state) => state.handbooks.officeType);

  useEffect(() => {
    if (officeTypeId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == officeTypeId) || null);
    }
  }, [officeTypeId, items]);

  return (
    <>
      {officeTypeId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {officeTypeId !== -1 && item !== null && (
        <Chip variant="dot" color="primary">
          {item?.display_name}
        </Chip>
      )}
      {officeTypeId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
